import { Add, Delete } from '@mui/icons-material';
import { Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addReasonAPI } from '../../../redux/actions';
import { showToast } from '../../../services/functions';
import theme, { buttonClasses, inputClasses, textClasses } from '../../../static/styles/theme'

export default function AddReason({open,setOpenReasonModel,type,fetchNewData}) {
    const dispatch = useDispatch();
    const [reasonToAdd, setReasonToAdd] = useState([""]);
    const handleClose = () => {
        setOpenReasonModel(false);
    }

    const handleChange = (e, i) => {
        let old =[...reasonToAdd];
        old.splice(i, 1, e.target.value);
        setReasonToAdd(old);
    }

    const handleDelete = (i) => {
        let old =[...reasonToAdd];
        old.splice(i, 1);
        setReasonToAdd(old);
    }

    // const handleAdd = () => {
    //     let old =[...reasonToAdd];
    //     old.push("")
    //     setReasonToAdd(old);
    // }
    
    const handleSubmit = () => {
        const invalid = reasonToAdd.filter(u => u=="");
        if(invalid.length > 0){
            showToast("Reason field is empty please fill it", true)
        }
        else{
            dispatch(addReasonAPI({reason:reasonToAdd[0],type:type}, (data={}) => {
                // showToast(data.message, !data.success);
                if(data.success){
                    setReasonToAdd([""])
                    handleClose();
                    if(fetchNewData){
                        fetchNewData()
                    }
                }
            }));
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={"paper"}
            PaperProps={{ sx: { width: "100%" } }}
            maxWidth={"sm"}
        >
            <DialogContent>
                <Typography sx={{...textClasses.cardTitle}}>Add Reason</Typography>
                <Grid container sx={{border: "1px solid #D9D9D9", borderRadius: "8px", p: 3, mt: 2}}>
                    <Grid container spacing={2} sx={{mb: 1}}>
                        <Grid container item sm={5} xs={5}>
                            <Typography sx={{...textClasses.boldText}}>Reason</Typography>
                        </Grid>
                    </Grid>
                    {
                        reasonToAdd.map((r, i) => {
                            return (
                                <Grid container spacing={2}>
                                    <Grid container item sm={10} xs={10} data-testid="reason-input">
                                        <TextField value={r} onChange={(e) => handleChange(e, i)} size='small' fullWidth type="text" variant="outlined" sx={{...inputClasses.shadowField}} />
                                    </Grid>
                                    {/* <Grid container item sm={2} xs={5} justifyContent="center" data-testid="delete-icon">
                                        <IconButton sx={{color: "red"}} onClick={() => handleDelete(i)}>
                                            <Delete fontSize='inherit'/>
                                        </IconButton>
                                    </Grid> */}
                                </Grid>
                            )
                        })
                    }
                    
                    {/* <Typography sx={{...textClasses.normalText, color: theme.themeOrange, cursor: "pointer", mt: 2}} onClick={handleAdd}><Add fontSize='inherit'/>Add New Reason</Typography> */}
                </Grid>
                <Grid container sx={{mt: 2}}>
                    <Button data-testid="cancel-btn" size='small' variant='outlined' sx={{...buttonClasses.lynkitBlackFill, height: "40px", minWidth: "150px"}} onClick={handleClose}>Cancel</Button>
                    <Button data-testid="submit-btn" size='small' variant='outlined' sx={{...buttonClasses.lynkitOrangeFill, height: "40px",  minWidth: "150px", ml: 2}} onClick={handleSubmit}>Submit</Button>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}
